import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 37 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"i-552954775__b\" width=\"24\" height=\"32\" x=\"6\" y=\"1\" maskUnits=\"userSpaceOnUse\" style=\"mask-type:alpha;\"><circle cx=\"18.332\" cy=\"8.132\" r=\"6.632\" fill=\"#000\"></circle><ellipse cx=\"18.333\" cy=\"26.366\" fill=\"url(#i-552954775__a)\" opacity=\".35\" rx=\"11.605\" ry=\"6.632\"></ellipse></mask><g mask=\"url(#i-552954775__b)\"><path fill=\"#2D7FF9\" d=\"M.333 0h36v36h-36z\"></path></g><defs><linearGradient id=\"i-552954775__a\" x1=\"5.922\" x2=\"26.503\" y1=\"23.323\" y2=\"36.191\" gradientUnits=\"userSpaceOnUse\"><stop></stop><stop offset=\"1\" stop-opacity=\".6\"></stop></linearGradient></defs>", 3)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "TopInfoHuman"}) } }